// extracted by mini-css-extract-plugin
export default {"main":"FAQs_main__5010n","contentCont":"FAQs_contentCont__89zrO","list":"FAQs_list__2CKaL","listItem":"FAQs_listItem__r9Cfn","head":"FAQs_head__QUwe7"};